export function transformTime(zone, date) {
    if(date) {
        return new Date(new Date(date).toLocaleString('zh-CN', { timeZone: zone })).getTime();
    }else {
        return new Date(new Date().toLocaleString('zh-CN', { timeZone: zone })).getTime();
    }
}
